<template>
    <v-dialog
        class="hide-on-print"
        v-model="innerOpen"
        persistent
        width="800">

        <v-card class="hide-on-print">
            <v-toolbar color="blue darken-3" dark>
                <v-toolbar-title>Transfer visa to New Passport</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
                <v-form lazy-validation ref="transferToNewRef">
                    <v-layout row wrap class="px-0 pt-5">
                        <v-flex xs6 class="pr-2">
                            <v-text-field
                                label="New passport number * "
                                outlined
                                :rules="[rules.required]"
                                v-model="formData.passport_number"
                            />
                        </v-flex>
                      <v-flex  xs6>
                        <v-autocomplete
                            :clearable="true"
                            :items="all"
                            :rules="[rules.required]"
                            item-text="country_name"
                            item-value="id"
                            label="Select Document Holding Country *"
                            outlined
                            v-model="formData.document_country_id"
                        ></v-autocomplete>
                      </v-flex>
                        <v-flex xs6 class="pr-3 pl-3">
                            <new-date-picker
                                label="Passport expiry date *"
                                v-model="formData.passport_expiry_date"
                            />
                        </v-flex>
                        <v-flex xs12 class="mt-4">
                            <v-file-input
                                outlined
                                label="Passport image * "
                                :rules="[rules.required]"
                                v-model="formData.passport_image"
                            ></v-file-input>
                        </v-flex>
                    </v-layout>
                </v-form>

            </v-card-text>
            <v-divider style="margin-top:31px;"/>
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    @click="cancel"
                    class="white--text"
                    color="red darken-3"
                >Cancel
                </v-btn>
                <v-btn
                    @click="save"
                    class="white--text"
                    color="blue darken-3"
                >Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import {validationMixin} from "../../mixins/validationMixin";
    import {VERSIONED_API_URL} from "../../config/config";
    import Http from "axios"
    import NewDatePicker from "../NewDatePicker";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "ManualPaymentDialog",
        components: {NewDatePicker},
        props: ['value', 'submission_no'],
        mixins: [validationMixin],
        data() {
            return {
                formData: {},
                innerOpen: false,
            }
        },
        watch: {
            value(input) {
                this.innerOpen = input;
            },
            innerOpen(value) {
            }
        },
      computed:{
       ...mapGetters('CountryList',['all'])
      },
        methods: {
          ...mapActions('CountryList',['fetchAllCountries']),
            async save() {
                if (this.$refs.transferToNewRef.validate() && this.formData.passport_expiry_date !== 'undefined') {
                    try {
                        const formData = new FormData();
                        formData.append('passport_number', this.formData.passport_number);
                        formData.append('document_country_id', this.formData.document_country_id);
                        formData.append('expiry_date', this.formData.passport_expiry_date);
                        formData.append('file', this.formData.passport_image);
                        console.log(formData);
                        const response = await Http.post(VERSIONED_API_URL + '/visa-requests/transfer-to-new/' + this.submission_no, formData);
                        this.$store.commit('Notification/showSuccess', response.data.message);
                        this.paymentData = {};
                        this.$emit('input', false);
                        this.innerOpen = false;
                        this.$emit('transferred')
                    } catch (e) {
                        this.$store.commit('Notification/showError', e.response.data.message);
                    }

                }
                else{
                  this.$store.commit('Notification/showError', 'Invalid Form Data');
                }
            },
            cancel() {
                this.paymentData = {};
                this.innerOpen = false;
                this.$emit('input', false)
            }
        },
      mounted() {
          this.fetchAllCountries()
      }
    }
</script>

